import styled, { css } from 'styled-components'
import { Select, MenuItem } from '@material-ui/core'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const StyledSelect = styled(Select)`
  background-color: ${({ theme }) => theme.colors.mainBg} !important;

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
`

export const StyledMenuItem = styled(MenuItem)``

type PendencyStatusProps = {
  pendencyStatus?: string
}

export const PendencyStatus = styled.span<PendencyStatusProps>`
  background-color: #fff4ec;
  padding: 7.5px 20px;
  border: 1px solid #ff8f39;
  width: 140px;
  text-align: center;
  border-radius: 20px;
  color: #ff8f39;
  font-weight: 500;
  font-size: ${({ theme }) => theme.font.sizes.small}
    ${(props) =>
      props.pendencyStatus &&
      props.pendencyStatus === 'Aprovado' &&
      css`
        background-color: #edf9f0;
        color: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
      `}
    ${(props) =>
      props.pendencyStatus &&
      props.pendencyStatus === 'Alterado' &&
      css`
        background-color: #eef2fa;
        color: #2e5aac;
        border: 1px solid #2e5aac;
      `};
`
export const NoStatusSelected = styled.span`
  background-color: #eef2fa;
  padding: 7.5px 20px;
  border: 1px solid #616161;
  width: 150px;
  text-align: center;
  border-radius: 20px;
  color: #616161;
  font-weight: 500;
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  margin-right: -18px;
  z-index: 1;
`
